<template>
    <div>
        <buttonlist
                @help="help"
                @reflash="reflash"
                @del="batchdel"
                @exps="exps"
                @add="add"
				ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Name" :label="$t('getapi[3150]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="departmentName" :label="$t('getapi[3151]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Description" :label="$t('getapi[2078]')" width="100">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Remarks" :label="$t('getapi[143]')" width="100">
            </el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="edit(scope.row)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[1146]')"
                            :cancelButtonText="$t('getapi[2054]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[6049]')"
                            @onConfirm="del(scope.row)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-dialogDrag :title="$t('getapi[1064]')" :visible.sync="isVisible" width="30%">
           <!-- <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px" label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[3150]')"><el-input v-model="dataDetail.name"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[3151]')">
                                    <el-select filterable v-model="dataDetail.department_id" size="mini">
                                        <el-option v-for="item in DepartmentInfo" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[2078]')"><el-input v-model="dataDetail.description"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[143]')"><el-input v-model="dataDetail.remarks"></el-input></el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[3150]')}}</td>
                        <td><el-input v-model="dataDetail.name"></el-input></td>
                        <td>{{$t('getapi[3151]')}}</td>
                        <td>
                            <routejump :urlNo="28" :isDialog="1" @callback="beforeRoutJump">
                            <el-select filterable v-model="dataDetail.department_id" size="mini">
                                <el-option v-for="item in DepartmentInfo" :key="item.Code" :label="item.Name"
                                           :value="item.Code"></el-option>
                            </el-select>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2078]')}}</td>
                        <td><el-input v-model="dataDetail.description"></el-input></td>
                        <td>{{$t('getapi[143]')}}</td>
                        <td><el-input v-model="dataDetail.remarks"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'postinfo',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail:{},
                oldDataDetail:[],
                DepartmentInfo: [],
				btn: {
					del: false,
					edit: false
				},
                selectIDData: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.DepartmentInfo = Array.methods.getDepartmentInfo();
            that.getView(),
			that.authority();			
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1064]"),this.$t("getapi[12]"));
            },
			//按钮操作权限
			authority() {
				let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
				//只读权
				if (that.$limits.ReadOnlyRights('plv2', 3, 1)) {
					that.$refs.SetBtn.SetButtonEnable('refresh,export');
				}
				//操作权
				if (that.$limits.authority('plv2', 3, 1) == 2) {
					if (that.$limits.authority('plv3', 3, 1) == 0) {//查询级
						that.btn.edit = false;
						that.btn.del = false;
						that.$refs.SetBtn.SetButtonEnable('refresh,export');
					}
					if (that.$limits.authority('plv3', 3, 1) == 1) {//编辑级
						that.btn.edit = true;
						that.btn.del = false;
						that.$refs.SetBtn.SetButtonEnable('create,refresh,export');
					}
					if (that.$limits.authority('plv3', 3, 1) == 2) {//删除级
						that.btn.edit = true;
						that.btn.del = true;
						that.$refs.SetBtn.SetButtonEnable('create,del,refresh,export');
					}
				}
			},
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let data = {

                };
                that.$http.urlpost('/Sys/Currency/GetPostList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.Table;
                        that.loading = false;
						that.authority();		
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
				that.authority();		
            },
            edit(row) {
                let that = this;
                that.isVisible = true
                let parm = {
                    Id: row.num
                }
                that.$http.urlpost('/Sys/Currency/GetPostInfo', parm, function(res) {
                    if(res.Success == 1){
                        that.dataDetail = res.DataContent
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                    }
                });
            },
            // 导出
            exps() {
                let that = this;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[1064]')
                };
                that.$http.urlpost('/Sys/Currency/PostExportToExecl', parm, function(res) {
                    if(res.Success == 1){
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            save() {
                let that = this;
                let datetime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString()
                that.dataDetail.updateuser = that.user
                that.dataDetail.updatetime = datetime
                let arr = []
                arr = [...arr,that.dataDetail]
                let parm = arr
                that.$http.urlpost('/Sys/Currency/SavePost', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false
                        that.getView()
                    }
                });
            },
            add() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.isVisible = true;
                that.dataDetail = {
                    num: '',
                    name: '',
                    description: '',
                    department_id: null,
                    remarks: '',
                    createruser: that.user,
                    createtime: datetime,
                    updateuser: '',
                    updatetime: '',
                    isdelete: false,
                    issealed: false
                };
            },
            del(row) {
                let that = this;
                let parm = {
                    ids: row.num,
                    exclusively_id: 0
                };
                that.$http.urlpost('/Sys/Currency/DelPostByID', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView();
                    }
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].num);
                }
            },
            batchdel() {
                let that = this;
                if(that.selectIDData.length == 0){
                    that.$message.warning(this.$t('getapi[1158]'));
                    return false
                }
                that.$confirm(this.$t('getapi[6049]'), this.$t('getapi[194]'), {
                    confirmButtonText: this.$t('getapi[1146]'),
                    cancelButtonText: this.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = '';
                        for (let i = 0; i < that.selectIDData.length; i++) {
                            ids = ids + that.selectIDData[i] + ',';
                        }
                        ids = ids.substr(0, ids.length - 1);
                        let parm = {
                            ids: ids,
                            exclusively_id: 0
                        };
                        that.$http.urlpost('/Sys/Currency/DelPostByID', parm, function(res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView();
                            }
                        });
                    })
                    .catch(() => {});
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
